var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [{ name: "tippy", rawName: "v-tippy" }],
      staticClass: "preset-thumbnail ml-1 cursor-pointer",
      class: {
        disabled: _vm.disabled,
      },
      attrs: { content: _vm.preset.label },
      on: { click: _setup.handleClick },
    },
    [
      _c(
        "div",
        { staticClass: "thumbnail-container" },
        [
          _c(_setup.CLazy, [
            _vm.preset.thumbnail
              ? _c("img", {
                  staticClass: "thumbnail-image",
                  attrs: {
                    src: _vm.preset.thumbnail,
                    alt: _vm.preset.label,
                    lazy: "",
                  },
                })
              : _c("img", {
                  staticClass: "thumbnail-image",
                  attrs: {
                    src: require("@/angular-app/images/placeholderCustomily.png"),
                    alt: _vm.preset.label,
                    lazy: "",
                  },
                }),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "preset-label" }, [
        _vm._v(_vm._s(_vm.preset.label)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }